unable to read source [project]/packages/core/src/constants.ts